import React from 'react';
import { formatBranding } from '../utils/helpers';

const ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
};

const escapeHtml = text => String(text).replace(/[&<>"]/g, c => ESCAPES[c]);

/**
 * Renders CMS text with "Decorzo Space" split into the two brand colours
 * (DECORZO orange / SPACE blue). Text is escaped first, so plain-text fields
 * stay plain text.
 *
 * Usage: <Branded as="h2" className="title" text={title} />
 */
export default function Branded({ as: Tag = 'span', text, ...rest }) {
  if (!text) return null;

  return (
    <Tag
      {...rest}
      dangerouslySetInnerHTML={{ __html: formatBranding(escapeHtml(text)) }}
    />
  );
}
